import React, { Fragment, useState } from 'react';
import { Redirect } from "react-router-dom";
import { Column, Hero, Button, Help } from 'rbx';
import '../../styles/prova.scss';
import ProvaService from '../../services/prova';
import { insProgress } from 'react-ins-progress-bar';
import Temporizador from '../shareds/temporizador';
import SpinnerModal from '../shareds/spinner_modal';

function Iniciar() {
    const [redirectToProva, setRedirectToProva] = useState(false);
    let objProva = localStorage.getItem('dadosInicio');
    let jsonProva = ('retrievedObject: ', JSON.parse(objProva));
    const [error, setError] = useState(false);
    const [response, setResponse] = useState('Dados Inválidos.');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        insProgress.start()
        setLoading(true);
        // se for processo seletivo top50 ou tradicional...
        const data = await ProvaService.dataatual();
        let dataServidor = data.data.dataatual

        // VALIDA DE A DATA FIM DA PROVA É MAIOR Q A DT ATUAL.
        if (dataServidor >= jsonProva.dt_prova) {
            const prova = await ProvaService.prova(jsonProva.id_inscricao);
            localStorage.setItem('dadosProva', JSON.stringify(prova.data));
            let questao1 = prova.data.psprovaalunoquestao[0].cd_questao;
            let id_prova = prova.data.id_prova;
            const questao = await ProvaService.questao(id_prova, questao1);
            localStorage.setItem('dadosQuestao', JSON.stringify(questao.data));

            // VALIDA DE A DATA FIM DA PROVA É MENOR Q A DT ATUAL.
            if (dataServidor <= prova.data.dt_fimprova) {
                setRedirectToProva(true);// retornar se nao tiver erro
            } else {
                setResponse('Data Limite para realizar a prova: ' + prova.data.dt_fimprova);
                setError(true)
                setLoading(false)
            }

        } else {
            setResponse('A prova inicia às: 15:00 horario de Brasília');
            setError(true)
            document.getElementById("iniciar").disabled = true;

            setTimeout(() => {
                document.getElementById("iniciar").disabled = false;
                setLoading(false)
            }, 30000);

        }

        insProgress.finish()
        // se for processo seletivo continuado chamar o andpoint que gera a prova.
    }

    if (redirectToProva)
        return <Redirect to={{ pathname: "/vestibular/prova" }} />

    return (
        <Fragment>
            {loading ? <SpinnerModal /> : ''}
            <Column.Group breakpoint="mobile" className="Body">
                <Column >
                    <p><strong>Nome: </strong>  <strong >{jsonProva.ds_nomealuno}</strong></p>
                    <p><strong>Número da Inscrição: </strong> <strong> {jsonProva.id_inscricao} </strong></p>
                    {jsonProva.cd_processosite === 201 ? <p><strong>Tire suas Dúvidas Aqui :</strong> <a href={jsonProva.ds_meet} target="_blank"> <strong>{jsonProva.ds_meet}</strong> </a>  </p> : ''}
                    {jsonProva.cd_processosite === 201 ? <Temporizador data={jsonProva.dt_prova} status={'INICIA EM  '} /> : ''}
                </Column>
            </Column.Group>
            <Hero className="Hero">
                <Hero.Head>
                    <img className="Img" src={`data:image/jpeg;base64,${jsonProva.ds_banner}`} alt="banner prova online." />
                </Hero.Head>
            </Hero>
            <Column.Group breakpoint="mobile" className="Body">
                <Column>
                    <img src={`data:image/jpeg;base64,${jsonProva.ds_instrucoes}`} alt="Instruções da Prova." />
                </Column>
            </Column.Group>
            <Column.Group breakpoint="mobile" className="Body">
                <Column >
                    <Button id="iniciar" color={"info"} onClick={handleSubmit} >
                        INICIAR A PROVA
                    </Button>
                    {error && <Help color="danger">{response} {error}  </Help>}
                </Column>
            </Column.Group>
        </Fragment>

    );
}

export default Iniciar;